import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	showDetails: {
		id: 'issue-field-service-entity.common.collapsible-field.card.show-details',
		defaultMessage: 'Show details',
		description: 'Label/Tooltip for button icon that shows details',
	},
	showLessDetails: {
		id: 'issue-field-service-entity.common.collapsible-field.card.show-less-details',
		defaultMessage: 'Show less details',
		description: 'Label/Tooltip for button icon that hides details',
	},
});
